import { Field } from "formik";
import { TextField } from "formik-mui";
import React, { useEffect, useMemo } from "react";
import Popup from "reactjs-popup";
import AddNewRooms from "../../Popups/AddNewRooms";

const Form3 = ({ values, rooms, setRooms, setNeededRooms }) => {
  const handleWorkingDays = (index) => {
    setRooms(allAddedRooms.map((item, i) => (i === index ? { ...item, selected: !item.selected } : item)));
  };

  const neededRooms = useMemo(() => {
    return rooms.filter((item) => item.room !== "" && item.selected);
  }, [rooms]);

  const allAddedRooms = useMemo(() => {
    return rooms.filter((item) => item.room !== "");
  }, [rooms]);

  useEffect(() => {
    setNeededRooms(neededRooms);
  }, [neededRooms, setNeededRooms]);

  return (
    <>
      <p className="text-[#131221] relative font-black text-[16px] md:text-[22px] self-start  mt-10">Add Home/Building Details</p>
      <div className="flex gap-2 items-center">
        <Popup
          trigger={
            <button className={`px-4 h-[40px] sticky min-w-[150px] bg-primary text-white rounded text-[12px] flex items-center justify-center`}>
              Add New Room room{" "}
            </button>
          }
          position="right center"
          modal
          nested
          contentStyle={{
            borderRadius: "12px",
            backgroundColor: "white",
            width: "fit-content",
            fontSize: "0.8rem",
            maxHeight: "98%",
            overflow: "auto",
          }}
        >
          {(close) => (
            <>
              <AddNewRooms close={close} rooms={rooms} setRooms={setRooms} />
            </>
          )}
        </Popup>

        <div className="my-8 flex  md:flex-row justify-start items-center flex-col gap-3  w-full md:w-[300px] overflow-x-scroll no-scrollbar">
          {allAddedRooms.map((item, index) => (
            <button
              key={index}
              onClick={() => handleWorkingDays(index)}
              className={`px-2 h-[40px] min-w-[100px] ${
                item.selected ? "bg-primary text-white rounded" : "border border-primary rounded text-primary"
              } text-[12px] flex items-center justify-center`}
            >
              {item.room}
            </button>
          ))}
        </div>
      </div>
      <div className="w-full flex flex-col items-center justify-center ">
        <div className="pt-6">
          <div className="mt-1 relative flex md:justify-end">
            <Field
              name={"note"}
              label="Property Note"
              value={values.note || ""}
              placeholder="Property Notes"
              multiline
              rows={6}
              component={TextField}
              className="border w-full md:w-[335px] min-h-[150px] border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Form3;
